module.exports = __webpack_public_path__ + "img/Fleet_icon.1c7b26e9.png";